import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useToast } from '@chakra-ui/react';
import { SelectItem } from '~/types';
import { getBranches, getGroups, getHeadOffices } from '~/services/Filter';
import { QueryBranches } from './types';

export function useFilterGroups(
  enabled = true,
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[]> {
  const toast = useToast();

  return useQuery<SelectItem[], unknown>(['groupsFilter'], () => getGroups(), {
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: false,
    ...options,
    onError: () => {
      toast({
        title: 'Erro',
        description: 'Erro ao buscar grupos, tente novamente',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    },
    enabled,
  });
}

export function useFilterHeadOffices(
  query: SelectItem[],
  enabled = true,
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[]> {
  const toast = useToast();
  const arrGroupsID = query?.map((g: SelectItem) => g.value);

  return useQuery<SelectItem[], unknown>(
    ['headOffices', arrGroupsID],
    () =>
      getHeadOffices({
        groups: arrGroupsID,
      }),
    {
      staleTime: 1000 * 60 * 2,
      refetchOnWindowFocus: false,
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar matrizes, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
      enabled,
    },
  );
}

export function useFilterBranches(
  query: QueryBranches,
  enabled = true,
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[]> {
  const toast = useToast();
  const arrGroupsID = query.groups?.map((g: SelectItem) => g.value);
  const arrHeadOfficesID = query.headOffices?.map((g: SelectItem) => g.value);

  return useQuery<SelectItem[], unknown>(
    ['branches', arrGroupsID, arrHeadOfficesID],
    () =>
      getBranches({
        groups: arrGroupsID,
        headOffices: arrHeadOfficesID,
      }),
    {
      staleTime: 1000 * 60 * 2,
      refetchOnWindowFocus: false,
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar filiais, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
      enabled,
    },
  );
}
